import {app} from "../firebase";
import {getDatabase,ref,get,set,push,child,remove,update} from "firebase/database"

function getEmployeesCollectionByCompany(companyId) {
  return `companies/${companyId}/employee`;
}

export const saveEmployee = async (companyId, data) => {
  const db = getDatabase(app);
  if (!companyId) {
    throw new Error("Nenhum ID de empresa fornecido.");
  }
  const cleanData = removeUndefined(data);
  const newEmployeeRef = push(ref(db, getEmployeesCollectionByCompany(companyId)));
  const newEmployeeId = newEmployeeRef.key;
  await set(newEmployeeRef, cleanData);

  return { id: newEmployeeId, ...cleanData };
};

function removeUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const deleteEmployee = async (companyId, employeeId) => {
  if (!companyId || !employeeId) throw new Error("IDs inválidos para exclusão");
  const db = getDatabase(app);

  await remove(ref(db, `${getEmployeesCollectionByCompany(companyId)}/${employeeId}`));
};

export const updateEmployee = async (companyId, employeeId, data) => {
  if (!companyId || !employeeId) throw new Error("IDs inválidos");
  const db = getDatabase(app);
  const cleanData = removeUndefined(data);
  await update(ref(db, `${getEmployeesCollectionByCompany(companyId)}/${employeeId}`), cleanData);
  return { id: employeeId, ...cleanData };
};

export const getEmployees = async (companyId) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, getEmployeesCollectionByCompany(companyId)));

  if (snapshot.exists()) {
    const data = snapshot.val();
    return Object.entries(data).map(([id, value]) => ({
      id,
      ...value,
    }));
  } else {
    return [];
  }
};


